import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CrudService } from '../shared/grid/crud.service';
import { SegProfileSummaryRequest, SegProfileSummaryResponse } from '../models/seg-profile-summary.model';

@Injectable({
  providedIn: 'root'
})
export class SegProfileService extends CrudService<SegProfileSummaryResponse> {

  constructor(http: HttpClient) {
    super('SegProfile', http);
  }

  setCurrent(id: string): Observable<boolean> {
    return this.http.post<boolean>(this.getApiUrl(`SegProfile/SetCurrent/${id}`), {});
  }

  unsetCurrent(id: string): Observable<boolean> {
    return this.http.post<boolean>(this.getApiUrl(`SegProfile/UnsetCurrent/${id}`), {});
  }

  getSegProfileSummary(request: SegProfileSummaryRequest): Observable<SegProfileSummaryResponse> {
    return this.http.post<SegProfileSummaryResponse>(this.getApiUrl(`SegProfile/GetSummary`), request);
  }
}
